import React from "react";

export default function NumberButton({
  number,
  isFilled,
  isSelected,
  onClick,
  owner,
}) {
  let bg = "bg-gray-700";
  if (isSelected) bg = "bg-blue-500 animate-pulse";
  else if (isFilled) bg = "bg-green-400 text-black";
  return (
    <button
      className={`w-10 h-10 rounded-xl flex items-center justify-center font-bold text-lg shadow ${bg} 
      ${isFilled ? "cursor-not-allowed" : "hover:bg-blue-300 hover:text-black"} 
      transition-all duration-150 relative`}
      onClick={!isFilled ? onClick : null}
      disabled={isFilled}
      title={owner?.username}
    >
      {number}
      {owner && (
        <span className="absolute bottom-0 right-0 text-xs bg-black bg-opacity-60 rounded px-1">
          {owner?.username?.slice(0, 4)}
        </span>
      )}
    </button>
  );
}
